import React from 'react';
const Template1 = (props) => {
    return (
        <div className="template-1">
           Name: {props.personalInfo.first_name.value+' '+props.personalInfo.last_name.value}<br/>
           Rollno: {props.next.rollno.value}<br/>
        </div>
    )
}
export default Template1;